import React, { ComponentType, FC, lazy, Suspense } from 'react';
import { useTranslation } from '../translations';

/**
 * Creates a lazy loaded component with loading from the provided resolver.
 */
export function makeLazyComponent<P extends object>(
  provider: () => Promise<
    | ComponentType<P>
    | {
        default: ComponentType<P>;
      }
  >,
): FC<P> {
  const LazyComponent = lazy(async () => {
    const resolved = await provider();
    return 'default' in resolved
      ? resolved
      : {
          default: resolved,
        };
  });

  const Comp: FC<P> = (props) => {
    const { ts } = useTranslation();

    return (
      <Suspense fallback={<span className="lazy-loaded-component">{ts('common.loading')}</span>}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        <LazyComponent {...(props as any)} />
      </Suspense>
    );
  };

  Comp.displayName = 'LazyWrapper';
  return Comp;
}
